module.exports = __webpack_public_path__ + "static/media/vip_1.382ec1a0.svg";